import {OptionsObject, SnackbarOrigin} from 'notistack';
export const MAX_SNACKBARS = 5;
export const DEFAULT_DURATION = 5000;
export const LONG_DURATION = 8000;
export const DEFAULT_ANCHOR: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'right'
};

export type SnackBarType =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'default'
  | 'e'
  | 's'
  | 'w'
  | 'i'
  | 'd';

export const SnackBarConfig = (
  type?: SnackBarType,
  duration?: number
): OptionsObject => {
  const config: OptionsObject = {
    variant: 'default',
    autoHideDuration: LONG_DURATION || DEFAULT_DURATION,
    anchorOrigin: DEFAULT_ANCHOR
  };

  switch (type) {
    case 'error':
    case 'e':
      config.variant = 'error';
      break;
    case 'success':
    case 's':
      config.variant = 'success';
      break;
    case 'warning':
    case 'w':
      config.variant = 'warning';
      break;
    case 'info':
    case 'i':
      config.variant = 'info';
      break;
    default:
      config.variant = 'default';
  }

  return config;
};
